function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isString(value) {
    return typeof value === 'string';
}
/* istanbul ignore next */
function levelToStatus(level) {
    if (level === 10 || level === 20) {
        return 'debug';
    }
    if (level === 40) {
        return 'warning';
    }
    if (level === 50) {
        return 'error';
    }
    if (level >= 60) {
        return 'critical';
    }
    return 'info';
}
export const formatPinoBrowserLogEvent = (logEvent) => {
    const { ts, messages, bindings, level: { value: levelValue } } = logEvent;
    const level = levelToStatus(levelValue);
    const timestamp = ts;
    const objMessages = messages.filter(isObject);
    const strMessages = messages.filter(isString);
    const logEntry = strMessages.join(' ');
    const defaultMetadata = {
        url: window.document.URL,
        level,
        browser: true
    };
    const bindingsAndMessages = bindings.concat(objMessages);
    const metadata = bindingsAndMessages.reduce((acc, el) => {
        return Object.assign(acc, el);
    }, defaultMetadata);
    return {
        metadata,
        log_entry: logEntry,
        timestamp
    };
};
//# sourceMappingURL=formatPinoBrowserLogEvent.js.map